import { ActionIcon, Group, Text, Tooltip } from '@mantine/core';
import { IconPencil, IconThumbDown, IconThumbUp } from '@tabler/icons-react';
import { useState } from 'react';

import { notifyError } from '@/lib/mutations';

import { sendFeedback } from './api';

type Rating = 'UTILE' | 'INCORRECTE' | 'A_MODIFIER';

/** 👍 / 👎 / ✏️ : avis sur une réponse, pour améliorer les prompts. */
export function Feedback({ requestId }: { requestId: string }) {
  const [given, setGiven] = useState<Rating | null>(null);
  const give = (rating: Rating) => {
    setGiven(rating);
    sendFeedback(requestId, rating).catch((e: unknown) => {
      setGiven(null);
      notifyError(e);
    });
  };
  if (given) {
    return (
      <Text size="xs" c="dimmed">
        Merci pour votre avis.
      </Text>
    );
  }
  const items: [Rating, string, typeof IconThumbUp][] = [
    ['UTILE', 'Réponse utile', IconThumbUp],
    ['INCORRECTE', 'Réponse incorrecte', IconThumbDown],
    ['A_MODIFIER', 'À modifier', IconPencil],
  ];
  return (
    <Group gap={4}>
      {items.map(([rating, label, Icon]) => (
        <Tooltip key={rating} label={label}>
          <ActionIcon
            variant="subtle"
            color="gray"
            size="sm"
            aria-label={label}
            onClick={() => give(rating)}
          >
            <Icon size={14} />
          </ActionIcon>
        </Tooltip>
      ))}
    </Group>
  );
}

export function AiNotice({ children }: { children?: string }) {
  return (
    <Text size="xs" c="dimmed" fs="italic">
      {children ?? 'Proposition générée par l’IA, à vérifier par le professionnel de santé.'}
    </Text>
  );
}
